import { useTranslation } from "react-i18next";
import { Building, Building2 } from "lucide-react";

const SCOPES = [
  { key: "company", icon: Building2, color: "bg-sky-500" },
  { key: "branches", icon: Building, color: "bg-emerald-500" },
];

// تبويبات نطاق التنظيم (الشركة / الفروع) بنفس أسلوب بلاطات الرئيسية ثلاثية الأبعاد.
export const OrgScopeTabs = ({ scope, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-2 sm:max-w-md" data-testid="org-scope-tabs">
      {SCOPES.map(({ key, icon: Icon, color }, index) => {
        const active = scope === key;
        return (
          <button
            key={key} type="button" data-testid={`org-scope-${key}`}
            onClick={() => onChange(key)}
            style={{ animationDelay: `${index * 45}ms` }}
            className={`group animate-rise-in flex items-center gap-2 rounded-3xl bg-background px-3 py-2.5 transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 ${
              active ? "shadow-neu-in text-primary" : "shadow-neu-sm hover:shadow-neu text-foreground"
            }`}
          >
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white shadow-neu-sm ${color}`}>
              <Icon className="h-5 w-5" strokeWidth={2.4} />
            </span>
            <span className="text-[12px] font-bold">{t(`org.scope.${key}`)}</span>
          </button>
        );
      })}
    </div>
  );
};
